export class ProgramAdministratorDeactivateOptionsModel {
	institute_id: number;
	institute_title: string;
}

export interface ProgramAdminDeactivateArgument {
	deactivate: number[];
	deactivation_reason: string;
}
